// w20.js
import React from 'react';
import WW from './ww';
import { pageConfigs } from '../../configs';

const W20 = () => {
  return <WW config={pageConfigs.w20} />;
};

export default W20;
